import { AddPresentationModalProps } from './AddPresentationModal';
import { openModal } from '@core/components/ModalStack';

export async function openAddPresentationModal(props: AddPresentationModalProps) {
  const { AddPresentationModal } = await import('./AddPresentationModal');

  openModal(AddPresentationModal, props);
}
